import React from 'react';
import ShadowContainer from './ShadowContainer';
import Button from './Button';
import Highlight from './Highlight';  

const BusinessSupport = () => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.imageWrapper}>
     {/*
<ShadowContainer 
  Image={SupportImage} 
  width={640} 
  height={454}  
  imageStyle={{ objectPosition: 'left top'}} 
/>
*/}

      </div>
      <div style={styles.textWrapper}>
        <Highlight width={618} height={348} /> 
        <div style={styles.textBox}>
          <h3 style={styles.heading}>Potpuna podrska biznisu</h3>
          <p style={styles.text}>
            Ovde ide tekst o admin panelu
          </p>
          <Button
            width={250} 
            height={80} 
            borderColor="yellow" 
            backgroundColor="#d3e205" 
            text="Zatraži deo" 
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessSupport;

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgb(23, 23, 24)',
    padding: 40,
    position: 'relative',
  },
  imageWrapper: {
    marginRight: '100px',  
  },
  textWrapper: {
    position: 'relative',
    width: 618,
    height: 348,
    zIndex: 0,
  },
  textBox: {
    position: 'relative',
    backgroundImage: 'linear-gradient(232deg, rgba(153, 153, 153, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%)',
    padding: '20px',
    borderRadius: '12px',
    width: 618,
    height: 348,
    zIndex: 2,
    backdropFilter: 'blur(6px)',
  },
  heading: {
    fontSize: '48px',
    fontWeight: 700,
    backgroundImage: 'linear-gradient(235.42deg, #EEFF00 0%, #B6BB6C 100%)',
    backgroundClip: 'text',
    color: 'transparent',
    marginBottom: 16,
    lineHeight: '64px',
  },
  text: {
    fontSize: '18px',
    color: '#ffffff',
    lineHeight: '28px',
    marginBottom: 24,
  },

 
};
